import { indexItems } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-18 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-2 text-center">
          专题合集
        </h2>
        <p className="text-foreground-500 text-sm text-center mb-10">
          按类型和主题精心策划的影视专题，发现更多精彩
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {indexItems.slice(0, 6).map((item) => (
            <div
              key={item.id}
              className="group rounded-xl overflow-hidden bg-background-100 border border-background-200/70 cursor-pointer transition-all duration-200 hover:border-primary-300"
            >
              <div className="relative h-40 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <span className="absolute bottom-3 left-3 px-3 py-1 rounded-full bg-white/20 backdrop-blur-sm text-white text-xs font-medium whitespace-nowrap">
                  {item.count}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-bold font-heading text-foreground-900 mb-1 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
          {indexItems.length >= 7 && (
            <div
              key={indexItems[6].id}
              className="rounded-xl overflow-hidden bg-background-100 border border-background-200/70 cursor-pointer transition-all duration-200 hover:border-primary-300 sm:col-span-2 lg:col-span-3"
            >
              <div className="flex flex-col sm:flex-row">
                <div className="relative h-40 sm:h-auto sm:w-64 flex-shrink-0 overflow-hidden">
                  <img
                    src={indexItems[6].image}
                    alt={indexItems[6].title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    loading="lazy"
                  />
                </div>
                <div className="p-5 flex-1">
                  <h3 className="text-base font-bold font-heading text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                    {indexItems[6].title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                    {indexItems[6].description}
                  </p>
                  <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium whitespace-nowrap">
                    {indexItems[6].count}
                  </span>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}